module.exports = __webpack_public_path__ + "static/sport/bgi-input.26b0e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/bgi-input.png
// module id = ueap
// module chunks = 0